export default __webpack_public_path__ + "static/media/IconDesc_Branch.256.ca6b6de8.png";